import {Component, computed, input} from '@angular/core';
import {IackathonSave} from '../../../../services/iackathon-saves.service';

@Component({
  selector: 'app-iackathon-step-rate',
  imports: [],
  templateUrl: './iackathon-step-rate.component.html',
  styleUrl: './iackathon-step-rate.component.scss',
})
export class IackathonStepRateComponent {
    save = input.required<IackathonSave>();
    private state = computed(() => this.save()?.attributes.content.state);

}
